"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/USFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_240)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_240`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-4.19995 0H31.8V24H-4.19995V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-4.19995 0H31.8V1.84561H-4.19995V0ZM-4.19995 3.69123H31.8V5.53684H-4.19995V3.69123ZM-4.19995 7.38246H31.8V9.22807H-4.19995V7.38246ZM-4.19995 11.0737H31.8V12.9193H-4.19995V11.0737ZM-4.19995 14.7719H31.8V16.6175H-4.19995V14.7719ZM-4.19995 18.4632H31.8V20.3088H-4.19995V18.4632ZM-4.19995 22.1544H31.8V24H-4.19995V22.1544Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-4.19995 0H13.8V12.9193H-4.19995V0Z",
					fill: "#2E52B2"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.845539 9.74743L-1.12624 8.84919L-1.43501 9.74743H-2.36133L-1.61045 10.2878L-1.89115 11.186L-1.12624 10.6316L-0.382381 11.186L-0.6701 10.2878L0.0948122 9.74743H-0.845539ZM3.10534 9.74743L2.81762 8.84919L2.52288 9.74743H1.59657L2.34744 10.2878L2.06674 11.186L2.81762 10.6316L3.57551 11.186L3.29481 10.2878L4.04569 9.74743H3.10534ZM7.07025 9.74743L6.7685 8.84919L6.48779 9.74743H5.54043L6.31236 10.2878L6.01762 11.186L6.7685 10.6316L7.54043 11.186L7.24569 10.2878L7.99657 9.74743H7.07025ZM11.0141 9.74743L10.7334 8.84919L10.4387 9.74743H9.50534L10.2632 10.2878L9.98253 11.186L10.7334 10.6316L11.4913 11.186L11.1895 10.2878L11.9615 9.74743H11.0141ZM2.81762 5.28428L2.52288 6.18252H1.59657L2.34744 6.73691L2.06674 7.62112L2.81762 7.07375L3.57551 7.62112L3.29481 6.73691L4.04569 6.18252H3.10534L2.81762 5.28428ZM-1.12624 5.28428L-1.43501 6.18252H-2.36133L-1.61045 6.73691L-1.89115 7.62112L-1.12624 7.07375L-0.382381 7.62112L-0.6701 6.73691L0.0948122 6.18252H-0.845539L-1.12624 5.28428ZM6.7685 5.28428L6.48779 6.18252H5.54043L6.31236 6.73691L6.01762 7.62112L6.7685 7.07375L7.54043 7.62112L7.24569 6.73691L7.99657 6.18252H7.07025L6.7685 5.28428ZM10.7334 5.28428L10.4387 6.18252H9.50534L10.2632 6.73691L9.98253 7.62112L10.7334 7.07375L11.4913 7.62112L11.1895 6.73691L11.9615 6.18252H11.0141L10.7334 5.28428ZM-1.12624 1.7334L-1.43501 2.61761H-2.36133L-1.61045 3.17199L-1.89115 4.06322L-1.12624 3.50884L-0.382381 4.06322L-0.6701 3.17199L0.0948122 2.61761H-0.845539L-1.12624 1.7334ZM2.81762 1.7334L2.52288 2.61761H1.59657L2.34744 3.17199L2.06674 4.06322L2.81762 3.50884L3.57551 4.06322L3.29481 3.17199L4.04569 2.61761H3.10534L2.81762 1.7334ZM6.7685 1.7334L6.48779 2.61761H5.54043L6.31236 3.17199L6.01762 4.06322L6.7685 3.50884L7.54043 4.06322L7.24569 3.17199L7.99657 2.61761H7.07025L6.7685 1.7334ZM10.7334 1.7334L10.4387 2.61761H9.50534L10.2632 3.17199L9.98253 4.06322L10.7334 3.50884L11.4913 4.06322L11.1895 3.17199L11.9615 2.61761H11.0141L10.7334 1.7334Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_240`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as USFlag };
